var map = {
	"./ca/translation.json": [
		19250,
		9250
	],
	"./en/translation.json": [
		37743,
		7743
	],
	"./es/translation.json": [
		49297,
		9297
	],
	"./fr/translation.json": [
		6093,
		6093
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97148;
module.exports = webpackAsyncContext;